import type { EmojiClickData, PickerProps } from 'emoji-picker-react'
import EmojiPicker, { EmojiStyle, Theme } from 'emoji-picker-react'

import EmojiIcon from '@/assets/icons/icon-emoji.svg'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover.tsx'
import { IconButton } from '@/modules/chatting/ui/components/icon-button'
import { classNames } from '@/utils/helpers.ts'
import { useIsDarkTheme } from '@/utils/useTheme.tsx'

import './index.css'

interface Props {
  onEmojiClick?: (emojiClickData: EmojiClickData) => void
  pickerProps?: PickerProps
  small?: boolean
  popoverSide?: 'top' | 'right' | 'bottom' | 'left'
  basicIconStyle?: boolean
  tooltip?: string
  trigger?: JSX.Element
  open?: boolean
  onOpenChange?: (state: boolean) => void
}

export const EmojiPickerPopover = ({
  onEmojiClick,
  pickerProps,
  small = false,
  popoverSide = 'left',
  basicIconStyle = false,
  tooltip,
  trigger,
  open,
  onOpenChange,
}: Props) => {
  const isDarkMode = useIsDarkTheme()

  return (
    <Popover
      open={open}
      onOpenChange={onOpenChange}
    >
      <PopoverTrigger asChild>
        {trigger || (
          <IconButton
            icon={EmojiIcon}
            className={classNames(
              'cursor-pointer text-primary-500 hover:text-primary-400',
              { 'text-secondary-300 hover:text-primary-500': basicIconStyle },
            )}
            iconClassName={classNames(small ? 'w-4 h-4' : 'w-6 h-6')}
            tooltip={tooltip}
          />
        )}
      </PopoverTrigger>
      <PopoverContent
        align="center"
        side={popoverSide}
        className="z-[79] w-fit border-none p-0"
      >
        <EmojiPicker
          previewConfig={{ showPreview: false }}
          emojiStyle={EmojiStyle.APPLE}
          onEmojiClick={onEmojiClick}
          theme={isDarkMode ? Theme.DARK : Theme.LIGHT}
          className="emoji-picker max-h-[380px] max-w-[320px]"
          {...pickerProps}
        />
      </PopoverContent>
    </Popover>
  )
}
